export default "/static/media/icon-facebook.83d3c3e4.svg";